import styled from "styled-components";

import { theme } from "../../themes/themes";
export const ModalContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ContentModal = styled.div`
  display: grid;
  grid-template-rows: auto 1fr;
  background: ${({ theme }) => theme.primaryBackgroundLight};
  border: 1px solid ${({ theme }) => theme.neutral.gray[700]};
  box-sizing: border-box;
  box-shadow: 2px 2px 25px ${({ theme }) => theme.shadows.strong};
  border-radius: 4px;
  height: 80vh;
  max-height: 517px;
  width: 80%;
  max-width: 450px;
  @media only screen and (max-width: 768px) {
    max-width: 100vw;
    max-height: 100vh;
  }
`;
export const IconContent = styled.div`
  padding: 1em;
  border-bottom: 1px solid ${({ theme }) => theme.neutral.gray[400]};
  text-align: center;
  svg {
    font-size: xx-large;
  }
`;

export const Content = styled.div`
  display: grid;
  grid-template-rows: 1fr 1fr 2fr;
  padding: 3em;
  border-bottom: 1px solid ${({ theme }) => theme.neutral.gray[400]};
  text-align: center;
  svg {
    font-size: xx-large;
  }
  p {
    color: ${({ theme }) => theme.primary.purple};
    font-weight: 600;
  }
  textarea {
    border: 1px solid #dbd9d9;
    outline: none;
    resize: none;
  }
  textarea:placeholder {
    color: #dbd9d9;
  }
`;

export const ButtonDone = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 36px;
  left: 732px;
  top: 336px;
  background: ${({ theme }) => theme.button.primary};
  border-radius: 4px;
  border: none;
  margin: 1em auto;
  color: white;
  cursor: pointer;
  a {
    color: ${({ theme }) => theme.neutral.gray[200]};
    text-decoration: none;
    background-color: transparent;
  }
  &:disabled {
    opacity: 0.5;
  }
`;

export const SizeImgRating = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  flex-direction: row-reverse;
  svg {
    height: 30px !important;
    width: 30px !important;
    cursor: pointer;
  }
  .ImageRating:hover,
  .ImageRating:hover ~ .ImageRating {
    fill: #ffc502 !important;
  }
`;
